export default __webpack_public_path__ + "static/kajaki-e595712dc2f7be7e86244552340406a2.png";